import { render, staticRenderFns } from "./loginPassword.vue?vue&type=template&id=6e96d820&scoped=true"
import script from "./loginPassword.vue?vue&type=script&lang=js"
export * from "./loginPassword.vue?vue&type=script&lang=js"
import style0 from "./loginPassword.vue?vue&type=style&index=0&id=6e96d820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96d820",
  null
  
)

export default component.exports